

















































































import Vue from 'vue'
import * as Product from '@/interfaces/product'

interface ITextContent {
  text: string;
  font: string | null;
  size: string | null;
  u: string | null;
  strike: string | null;
  a: string | null;
}

export default Vue.extend({
  name: 'DescriptionElement',
  props: {
    data: {
      type: Object as () => Product.IProductContentDataIntro,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    textScale: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      content: [] as Array<any>,
      applyStyles: [] as Array<string>
    }
  },
  computed: {
    getPlainText (): string {
      // Get the text that is outside the tags <font color='#ffffff'>●</font>，任何角度不反光。
      if (this.data.content) { return this.data.content.replace(/<.*>/g, '') } else return ''
    }
  },
  watch: {
    data: function () {
      this.updateContent()
    }
  },
  created () {
    this.updateContent()
  },
  methods: {
    updateContent () {
      // Check type is text
      if (this.data.type === 1 || this.data.type === 5 || this.data.type === 7 || this.data.type === undefined) {
        this.parseContent(this.data.content)
        this.content.forEach((text, i) =>
          this.applyStyles.push(this.getTextStyle(text, i))
        )
      }
    },
    parseContent (targetString : string) {
      const regexp = /<.*?>/g
      // Get match result in tag
      const matchAll = [...targetString.matchAll(regexp)] as RegExpMatchArray[]
      // IterableIterator<RegExpMatchArray> use spread opreator assign to RegExpMatchArray[]
      let currentConfig = {} as any
      const content = [] as Array<any>
      // Check we have found some tags in string
      if (matchAll && matchAll.length >= 2) {
        const treeNodes = [] as Array<string>
        let testStartPosition = 0
        // Get the attributes in the string
        for (const match of matchAll) {
          if (match.length === 0) continue
          if (match === null || match.index === undefined) continue

          const currentMatchText = match[0]
          if (testStartPosition !== 0) {
            const targetSaveText = targetString.substring(testStartPosition, match.index)
            if (targetSaveText.length !== 0) {
              // Set text and push into content, ready to start new config
              currentConfig.text = targetSaveText
              content.push(currentConfig)
            }
          }
          testStartPosition = match.index + currentMatchText.length
          // Check if ending tag or not
          if (/<\s*\/.*>/g.test(currentMatchText)) {
            const endingTagMatchResult = currentMatchText.match(currentMatchText)
            if (endingTagMatchResult !== null) {
              if (treeNodes.length === 0) {
                throw new Error('Parsing error, no tag in treeNodes.')
              }
              // Ending tag, ex: </font>, get end tag name -> font
              const endTag = endingTagMatchResult[0].replace(/\W+/g, '')
              if (!treeNodes.includes(endTag) && treeNodes[treeNodes.length - 1] !== endTag) {
                throw new Error(`Parsing error, the order of tags is wrong, should be: ${endTag}`)
              } else {
                // Start new content object with set attributes but not text
                currentConfig = { ...currentConfig, text: '' }
                // Pop an apply attribute, remove property
                const removeTag = treeNodes.pop() || ''
                delete currentConfig[removeTag]
              }
            }
          } else {
            // Start new content object with set attributes but not text
            currentConfig = { ...currentConfig, text: '' }
            // Remove symbols with tag < > and use space to split string
            // <font color='#ffffff'> -> ["font", "color='#ffffff'""]
            const attributesPair = currentMatchText.replace(/<|>/g, '').split(' ')
            // Start a new tree node in current tree
            treeNodes.push(attributesPair[0])

            // Mapping
            try {
              if (attributesPair !== null && attributesPair[0] !== null && attributesPair[1] !== undefined) {
              // Get pure value in an attribute, ex: "color='#ffffff'" -> '#ffffff'
                const stringWithSingleQuotes: string | undefined = (attributesPair[1].match(/'.*?'/g) || '')[0] // "color='#ffffff'" or undefined
                // Remove single quotes and set key value pair
                currentConfig[`${attributesPair[0]}`] = stringWithSingleQuotes ? stringWithSingleQuotes.replace(/'/g, '') : stringWithSingleQuotes
              } else {
                // stike or underline without pair value
                currentConfig[`${attributesPair[0]}`] = true
              }
            } catch (error) {
              console.error(error)
            }
          }
        }

        // Push plain text which is outside tags to the content
        const firstMatchStartIndex = matchAll[0].index
        // Get first plain text after the lastest end tag
        const lastMatchEndIndex = (matchAll[matchAll.length - 1].index || 0) + matchAll[matchAll.length - 1][0].length
        const plainTextStart = targetString.substring(0, firstMatchStartIndex)
        const plainTextEnd = targetString.substring(lastMatchEndIndex, targetString.length)
        if (plainTextStart.length > 0) {
          content.unshift({ text: plainTextStart })
        }
        if (plainTextEnd.length > 0) {
          content.push({ text: plainTextEnd })
        }
      } else {
        // Pure text without any tags
        content.push({ text: targetString })
      }
      this.content = content
    },
    getDividerStyle (targetString: string) {
      const dividerConfig = targetString.split(',')
      return `border-top: ${dividerConfig[1]}px solid #${dividerConfig[0]}`
    },
    getTextClass (content: ITextContent) {
      const applyClass = []
      if (content) {
        if (content.u && content.strike) {
          applyClass.push('underline-strike')
        } else {
          if (content.u) { applyClass.push('underline') }
          if (content.strike) { applyClass.push('strike') }
        }
        if (content.text.trim().length === 0) {
          applyClass.push('empty')
        }
      }
      return applyClass
    },
    isLinkContent (content: ITextContent) {
      return !!content.a
    },
    getTextStyle (content: ITextContent, textIndex: number) {
      let applyStyle = ''
      if (content) {
        if (content.font) { applyStyle += ` color: ${content.font} !important;` }
        if (content.size) {
          const weight = content.size.charAt(content.size.length - 1).toUpperCase()
          if (weight === 'B') {
            applyStyle += ' font-weight: bold;'
          } else if (weight === 'L') {
            applyStyle += ' font-weight: lighter;'
          }
        }
      }
      if (!this.textScale) { applyStyle += ' font-size: 1rem !important;' }
      this.$nextTick(() => {
        if (this.applyStyles[textIndex] && content.size) {
          const el = document.getElementById(`element-${this.index}`) as HTMLElement
          const fontStyle = window.getComputedStyle(el || document.body, null).getPropertyValue('font-size')
          let baseFontSize = parseFloat(fontStyle) / 16
          // Disable text scale when text scale is set to 'false', ex: in home page
          if (!this.textScale) { baseFontSize = 1 }

          // #1.00N -> 1.00
          const ratio = parseFloat(content.size.substring(1, content.size.length - 1))
          const textElement = document.getElementById(`element-${this.index}-${textIndex}`) as HTMLElement
          if (textElement) { textElement.style.fontSize = `${ratio * baseFontSize}rem` }
        }
      })
      return applyStyle
    },
    getElementStyle () {
      let applyStyle = ''
      if (this.data) {
        if (this.data.paddingH) {
          applyStyle += ` padding-left: ${this.data.paddingH[0]}%; padding-right: ${this.data.paddingH[1]}%;`
        }
        if (this.data.marginV) {
          applyStyle += ` margin-top: ${this.data.marginV}%;`
        }
        if (this.data.kern) {
          applyStyle += ` letter-spacing: ${this.data.kern}px;`
        }
      }
      return applyStyle
    }
  }
})
